var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotationExpanded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.085 9.585H21.2577L23.1727 11.5L21.2577 13.415H6.085V9.585Z",
    stroke: "#0076A8",
    strokeWidth: 1.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 17.5H6.00012",
    stroke: "#0076A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5L6 17.5L8 19.5",
    stroke: "#0076A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationExpanded);
export default __webpack_public_path__ + "static/media/annotation-expanded.21a6e13561750645efc43a95c02d043a.svg";
export { ForwardRef as ReactComponent };